// Path: ./src/app/components/AccountCard/styled.ts
import { Button, styled as MuiStyled, ButtonProps } from "@mui/material";
import styled from "styled-components";

export const ColorButton = MuiStyled(Button)<ButtonProps>(() => ({
  backgroundColor: "#f58220",
  textTransform: "capitalize",
  fontSize: 18,
  "&:hover": {
    backgroundColor: "#f58220",
  },
}));

export const ListTableWrapper = styled.div`
  margin-top: 10px;
`;
